import { useMemo } from 'react'
import { Route, Routes, useRoutes } from 'react-router-dom'
import type { RouteObject } from 'react-router-dom'
import { moduleRoutes } from '@/modules/registry'
import { AppShell } from './AppShell'
import { Dashboard } from './Dashboard'
import { LoginPage } from './LoginPage'
import { MeContextProvider, useMe } from './MeContextProvider'
import { NotFound } from './NotFound'
import { ProtectedRoute } from './ProtectedRoute'

/** Router aplikacji: publiczne logowanie + reszta za ProtectedRoute. */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/logowanie" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <MeContextProvider>
              <AppShell>
                <ShellRoutes />
              </AppShell>
            </MeContextProvider>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

/** Trasy modułów filtrowane wg `/api/me/context` + „/" → Pulpit. */
function ShellRoutes() {
  const { moduleKeys } = useMe()

  const routes = useMemo<RouteObject[]>(
    () => [
      { index: true, element: <Dashboard /> },
      ...moduleRoutes(moduleKeys),
      { path: '*', element: <NotFound /> },
    ],
    [moduleKeys],
  )

  return useRoutes(routes)
}
